module.exports = __webpack_public_path__ + "img/application.1e419358.svg";